import React from 'react';
import { motion } from 'framer-motion';
import './BandDisplay.css';

const BandDisplay = () => {
  const logos = [
    { id: 1, name: 'Company A', image: 'img/brand_img/TGPL.png' },
    { id: 2, name: 'Company B', image: 'img/brand_img/delta.png' },
    { id: 3, name: 'Company C', image: 'img/brand_img/crompton.jpg' },
    { id: 4, name: 'Company D', image: 'img/brand_img/derco.png' },
    { id: 5, name: 'Company E', image: 'img/brand_img/donfoss.png' },
    { id: 6, name: 'Company F', image: 'img/brand_img/inovnce.png' },
    { id: 7, name: 'Company G', image: 'img/brand_img/seimens.png' },
	{ id: 8, name: 'Company H', image: 'img/brand_img/sendka.jpg' },
  ];

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2,
      },
    },
  };

  const logoVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    hover: { scale: 1.1, transition: { duration: 0.3 } },
  };

  return (
    <div className="band-display-container" id='brand'>
      <motion.h2
        className="band-display-header"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Our Trusted Partners
      </motion.h2>
      <motion.div
        className="band-display"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {logos.map((logo) => (
          <motion.div
            key={logo.id}
            className="logo-container"
            variants={logoVariants}
            whileHover="hover"
          >
            <img src={logo.image} alt={logo.name} className="logo-image" />
          </motion.div>
        ))}
      </motion.div>
      
    </div>
  );
};

export default BandDisplay;
